/* Dynamic Plot code copyright 2015 (c) Tuva Labs Inc. */
/**
 *
 * created by jpatel
 * Sort Order toggle component which allow users to switch between ascending and descending order of the attribute
 */

import React from 'react';
import ToolTip from '../common/ToolTip';

class SortOrderComponent extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
        value: this.props.attributeObj.isSortAscending ? "ascending" : "descending"
    };
  }

  changeHandler = (_value) => {
    this.setState({
      value: _value
    });

    // //pass message to plot on the update of the datatype for attribute
    // mediator.publish( "records:attributeSortOrderUpdated", {
    //   "attributeID": this.props.attributeObj.id,
    //   "sortOrder": _value
    // });
    // Get access to the parent component and reload it,
    // replace the attributeFilterComponent based on categorical
    // or numerical change
    // this.props.dataType = event.target.value;
    // this.setProps({
    //   dataType : event.target.value
    // });
    // Need help: for some reason this.state doesn't get updated
    // may be its race condition, or I am missing something.
    this.props.handleChange(
       _value
    );
  }

  getLoc = (str) => {
    let Dyn = this.props.Dyn;
      return Dyn.loc( str );
  }

  render = () => {
    return (
      <div className={"tde-sort-order-component tde-row tde-divider-top tde-pt-4 tde-mt-4" + (this.props.reduceCaseCardWidth ? ' tde-px-2':' tde-px-3')}>
        <div className="tde-label tde-s1-size tde-font-weight-bold tde-attr-name tde-sort-order tde-mb-2">{ this.getLoc('Sort') }
            <ToolTip tip={this.props.attributeObj.getDataType() === 'numerical'?
                this.getLoc('Sort in ascending or descending order') :
                this.getLoc('Flip or reverse current order of categories')}
            Dyn={this.props.Dyn} dir="r"><i role="button" className="tde-i tde-i-help tde-ml-1" aria-label={this.props.attributeObj.getDataType() === 'numerical'?
                this.getLoc('Sort in ascending or descending order') :
                this.getLoc('Flip or reverse current order of categories')}><span className="tde-sr-only">{this.props.attributeObj.getDataType() === 'numerical'?
                this.getLoc('Sort in ascending or descending order') :
                this.getLoc('Flip or reverse current order of categories')}</span></i></ToolTip></div>
        <div>
            <button
                aria-pressed={this.state.value === 'ascending'}
                aria-label={this.getLoc('Sort Attribute in Ascending Order')}
                onClick={() => this.changeHandler("ascending")}
                className={"tde-m-0 tde-btn" + (this.state.value === 'ascending' ? ' tde-active' :'')}>

                        <i className={'tde-i ' + (this.props.attributeObj.getDataType() === 'numerical'? 'tde-i-asc-number': 'tde-i-asc-alphabet')}>
                            <span className="tde-sr-only">{ this.getLoc('Ascending') }</span>
                        </i>

            </button>
            <button
                aria-pressed={this.state.value === 'descending'}
                aria-label={this.getLoc('Sort Attribute in Descending Order')}
                onClick={ () =>this.changeHandler("descending")}
                className={"tde-m-0 tde-ml-2 tde-btn" + (this.state.value === 'descending' ? ' tde-active' :'')}>

                        <i className={'tde-i ' + (this.props.attributeObj.getDataType() === 'numerical'? 'tde-i-desc-number': 'tde-i-desc-alphabet')}>
                            <span className="tde-sr-only">{ this.getLoc('Descending') }</span>
                        </i>

            </button>
        </div>
      </div>
    );
  }
}

export default SortOrderComponent
